import React, { useEffect } from 'react';

type ComingSoonPlatform = 'apple' | 'android';

interface ComingSoonToastProps {
  onClose: () => void;
  platform?: ComingSoonPlatform;
}

const COPY: Record<ComingSoonPlatform, { title: string; subtitle: string }> = {
  apple: {
    title: 'Coming Soon to the App Store',
    subtitle: 'Join the waitlist to be first to ride',
  },
  android: {
    title: 'Coming Soon to Google Play',
    subtitle: 'Android beta is rolling — join the waitlist to ride',
  },
};

const ComingSoonToast: React.FC<ComingSoonToastProps> = ({ onClose, platform = 'apple' }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const copy = COPY[platform];

  return (
    <div
      className="fixed left-1/2 -translate-x-1/2 animate-fade-in-up rp-toast-above-nav"
      onClick={onClose}
      style={{
        // Stack above the bottom nav (z-50) so the toast stays readable/tappable.
        zIndex: 60,
      }}
    >
      <div className="flex items-center gap-3 px-6 py-3 rounded-xl shadow-2xl border"
        style={{
          background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
          borderColor: 'rgba(255, 107, 107, 0.3)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4), 0 0 16px rgba(255, 107, 107, 0.1)',
        }}
      >
        <span className="text-2xl">🏍️</span>
        <div>
          <p className="text-white font-semibold text-sm">{copy.title}</p>
          <p className="text-gray-400 text-xs">{copy.subtitle}</p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonToast;
